import { createReducer } from '@src/redux/helpers/createReducer';

import { SET_IS_EDITING } from './constants';

const initialState = {
  isEditing: false,
};

export const editingReducer = createReducer(initialState, {
  [SET_IS_EDITING]: (state, action) => {
    return {
      ...state,
      isEditing: action.payload,
    };
  },
});
